<nb-card>
  <nb-card-header>
    <h2>{{struttura.nome?.it || 'Struttura'}}</h2>
  </nb-card-header>
  <nb-card-body>
    <nb-tabset fullWidth>
      <nb-tab tabTitle="Informazioni">
        <div class="row show-grid">
          <nb-card-body>
            <div class="row">
              <div
                class="col-md-6"
                style="overflow: hidden;"
              >
<!-- 
                <google-map
                  [center]="struttura_position"
                  zoom=15
                ></google-map> -->


                <!-- <agm-map
                    #map
                    [latitude]="struttura.latitudine"
                    [longitude]="struttura.longitudine"
                    [zoom]=15
                  >
                    <agm-marker
                      [latitude]="struttura.latitudine"
                      [longitude]="struttura.longitudine"
                    ></agm-marker> 
                  </agm-map> -->
              </div>
              <div class="col-md-6">
                <ul class="list">
                  <div *ngIf="struttura.distretto && distretti?.get(struttura.distretto)">
                    <span>
                      <b>
                        <i class="ion-android-pin"></i>
                        Zona distretto:
                      </b>
                      {{ distretti?.get(struttura.distretto)?.nome || 'Non disponibile' }}
                      <br>
                      <hr>
                    </span>
                  </div>


                  <span *ngIf="struttura.indirizzo">
                    <b>
                      <i class="ion-android-navigate"></i> Indirizzo:
                    </b>{{ struttura.indirizzo || 'Non disponibile' }}
                    <br>
                    <hr>
                  </span>


                  <span *ngIf="struttura.indicazioni">
                    <b>
                      <i class="ion-help-circled"></i> Indicazioni:
                    </b>{{ struttura.indicazioni?.it || 'Non disponibile'}}
                  </span>
                  <span *ngIf="struttura.comune">
                    <b>
                      <i class="ion-android-mail"></i> Comune:
                    </b>{{ comuni?.get(struttura.comune)?.nome || 'Non disponibile' }}
                    <br>
                    <hr>
                  </span>

                  <span *ngIf="struttura.latitudine && struttura.longitudine">
                    <b>
                      <i class="ion-android-pin"></i> Coordinate: </b>
                    <a
                      href="https://www.google.com/maps/search/?api=1&query={{struttura.latitudine+','+struttura.longitudine}}"
                      target="_blank"
                    >
                      {{ struttura.latitudine | number : '1.4-4'  }}N - {{ struttura.longitudine | number : '1.4-4' }}E
                    </a>
                  </span>
                  <br>
                  <hr>
                  <span *ngIf="struttura.cap">
                    <b>
                      <i class="ion-android-mail"></i> CAP:</b>
                    {{ struttura.cap || 'Non disponibile' }}
                    <br>
                    <hr>
                  </span>

                  <span *ngIf="struttura.area_vasta">
                    <b>
                      <i class="ion-android-call"></i> Area vasta:</b>
                    {{ aree_vaste?.get(struttura.area_vasta)?.nome || 'Non disponibile' }}
                    <br>
                    <hr>
                  </span>
                  <span *ngIf="struttura.azienda_sanitaria">
                    <b>
                      <i class="ion-android-call"></i> Azienda sanitaria:</b> {{ aziende_sanitarie?.get(struttura.azienda_sanitaria)?.nome || 'Non
                      disponibile' }}
                    <br>
                    <hr>
                  </span>


                  <!-- <span *ngIf="struttura.responsabile">
                      <b>
                        <i class="ion-android-call"></i> Referente consultorio:</b> {{ struttura.responsabile || 'Non disponibile' }}
                    </span>
                    <span *ngIf="struttura.email">
                      <b>
                        <i class="ion-android-call"></i> Email referente consultorio:</b> {{ struttura.email || 'Non disponibile' }}
                    </span> -->
                </ul>
              </div>
            </div>
          </nb-card-body>
        </div>
      </nb-tab>
      <nb-tab
        *ngIf="struttura.percorso_gravidanza && (isAdmin || isReferente)"
        tabTitle="Consegna libretto"
      >
        <nb-card-body>
          <span>
            <b>
              <i class="ion-android-pin"></i>
              Consegna libretto attiva
            </b>
            <br>
            <hr>
          </span>

          <span>
            <b>
              <i class="ion-android-pin"></i>
              Referente struttura per invio password:
            </b>
            {{ struttura.referente_struttura }}
            <br>
            <hr>
          </span>


          <span>
            <b>
              <i class="ion-android-pin"></i>
              Email riferimento per invio password:
            </b>
            {{ struttura.email_referente_struttura }}
            <br>
            <hr>
          </span>

        </nb-card-body>
      </nb-tab>

      <nb-tab tabTitle="Servizi disponibili">
        <div>
          <nb-card-body>
            <div *ngIf="servizi_strutture">
              <ul class="list">
                <li *ngFor="let servizio of servizi_strutture">
                  <h6>{{tipi_serv_strut?.get(servizio.tipo_serv_strut)?.nome}} </h6>
                  <span>
                    <i class="ion-android-time"></i> {{servizio.giorni}}</span>
                  <br>
                  <hr>
                </li>
              </ul>
            </div>
            <div *ngElse>
              <span>Nessun servizio disponibile</span>
            </div>
          </nb-card-body>
        </div>
      </nb-tab>

      <nb-tab tabTitle="Orari">
        <div>
          <nb-card-body>
            <div *ngIf="orari_strutture">
              <table class="table">

                <thead>
                  <tr>
                    <th rowspan="2"></th>
                    <th rowspan="2"></th>
                    <th
                      colspan="2"
                      class="text-center mr-2"
                    >Mattina</th>
                    <th
                      rowspan="2"
                      class="text-center"
                    > </th>
                    <th
                      colspan="2"
                      class="text-center mr-2"
                    >Pomeriggio</th>
                    <th rowspan="2">Frequenza</th>
                    <th rowspan="2"></th>
                    <th rowspan="2"></th>
                  </tr>
                  <tr>

                    <th class="text-right"> dalle</th>
                    <th class="text-left"> alle</th>

                    <th class="text-right"> dalle</th>
                    <th class="text-left"> alle</th>

                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let orario of orari_strutture | orderBy: 'giorno'">
                    <td>
                      <i class="ion-android-time"></i>
                    </td>
                    <td>

                      {{orario.labelGiorno}}
                    </td>
                    <td>{{orario.apertura_mattina}}</td>
                    <td>{{orario.chiusura_mattina}}</td>
                    <td></td>
                    <td>{{orario.apertura_pomeriggio}}</td>
                    <td>{{orario.chiusura_pomeriggio}}</td>
                    <td>{{orario.label_frequenza}}</td>
                    <td>{{orario.sintesi}}</td>
                    <td>{{orario.note}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div *ngElse>
              <span>Nessun orario disponibile</span>
            </div>
          </nb-card-body>
        </div>
      </nb-tab>

      <nb-tab tabTitle="Contatti">
        <nb-card-body>
          <ul class="list">
            <span>
              <b>
                <i class="ion-android-call"></i> Contatti telefono:</b>
              <a href="tel:{{struttura.contatto_telefono}}">{{ struttura.telefono }}</a>
            </span>
            <br>
            <hr>
            <span>
              <b>
                <i class="ion-android-mail"></i> Email: </b>
              <a href="mailto:{{mailto_dest}}">{{struttura.email}}</a>
            </span>
            <br>
            <hr>
          </ul>
        </nb-card-body>
      </nb-tab>
    </nb-tabset>
  </nb-card-body>
</nb-card>
